<template>
  <b-card class="mt-5">
    <b-row>
      <!-- BOX CHART -->
      <b-col class="col-12">
        <b-row v-if="dashbaordRoleMode == 'center'" class="mt-3">
          <b-col class="col-6 col-md-3">
            <div class="card mb-4 mb-xl-0 box-main">
              <div class="card-body box-sub">
                <div class="row">
                  <div class="col text-center">
                    <h2 class="">{{ compliantStatistics.total }}</h2>
                    <span class="card-title">จำนวนเรื่องร้องทุกข์ทั้งหมด</span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col class="col-6 col-md-3">
            <div class="card mb-4 mb-xl-0 box-main">
              <div class="card-body box-sub">
                <div class="row">
                  <div class="col text-center">
                    <h2 class="">{{ compliantStatistics.inprocess }}</h2>
                    <span class="card-title">กำลังดำเนินการ</span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col class="col-6 col-md-3">
            <div class="card mb-4 mb-xl-0 box-main">
              <div class="card-body box-sub">
                <div class="row">
                  <div class="col text-center">
                    <h2 class="">{{ compliantStatistics.terminated }}</h2>
                    <span class="card-title">ยุติ</span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col class="col-6 col-md-3">
            <div class="card mb-4 mb-xl-0 box-main">
              <div class="card-body box-sub">
                <div class="row">
                  <div class="col text-center">
                    <h2 class="">{{ compliantStatistics.returned }}</h2>
                    <span class="card-title">ส่งคืน สคบ</span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-else-if="dashbaordRoleMode == 'district'" class="mt-3">
          <b-col class="col-6 col-md-4">
            <div class="card mb-4 mb-xl-0 box-main">
              <div class="card-body box-sub">
                <div class="row">
                  <div class="col text-center">
                    <h2 class="">{{ compliantStatistics.total }}</h2>
                    <span class="card-title">จำนวนเรื่องร้องทุกข์ทั้งหมด</span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col class="col-6 col-md-4">
            <div class="card mb-4 mb-xl-0 box-main">
              <div class="card-body box-sub">
                <div class="row">
                  <div class="col text-center">
                    <h2 class="">{{ compliantStatistics.inprocess }}</h2>
                    <span class="card-title">กำลังดำเนินการ</span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col class="col-6 col-md-4">
            <div class="card mb-4 mb-xl-0 box-main">
              <div class="card-body box-sub">
                <div class="row">
                  <div class="col text-center">
                    <h2 class="">{{ compliantStatistics.terminated }}</h2>
                    <span class="card-title">ยุติ</span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-2"
      ><b-col class="col-12">
        <b-card no-body class="pt-0">
          <div class="col text-left">
            <span class="card-title"
              >จำนวณเรื่องร้องทุกข์ประจำเดือนปี {{ dashboardYear }}</span
            >
          </div>
          <b-card-body>
            <vue-apex-charts
              ref="barChart"
              type="bar"
              height="350"
              :options="columChart.chartOptions"
              :series="columChart.series"
            />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BLink,
  BCard,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BModal,
  BOverlay,
} from "bootstrap-vue";

import VueApexCharts from "vue-apexcharts";

import appsettings from "@/store/app-settings";
import * as userData from "@/auth/localStorageUtils.js";
import * as provinceStore from "@/store/api/province/index.js";
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BCardText,
    BModal,
    BOverlay,
    VueApexCharts,
  },
  data() {
    return {
      compliantStatistics: {
        total: 0,
        inprocess: 0,
        terminated: 0,
        returned: 0,
      },
      dashboardYear: null,
      columChart: {
        series: [
          {
            name: "จำนวนเรื่องร้องทุกข์",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          title: {
            text: this.titleText,
            align: "left",
            style: {
              fontSize: "16px",
            },
          },
          colors: ["#5bc291", "#bff1b9", "#2F9E8F"],
          plotOptions: {
            bar: {
              columnWidth: "60%", // 100% ทำให้แท่งในกราฟติดกัน
              borderRadius: 10, // ปรับปลายแท่งในกราฟมีความโค้ง
              distributed: true, // ปรับแท่งในกราฟแยกออกจากกันตาม series.data ถ้าเป็น false **มันจะมอง series.data เป็นก้อนเดียวกันทำให้กำหนดสีแต่ละแท่งไม่ได้
              horizontal: false, // ปรับให้มุมมองกราฟแท่งเป็นแถวตั้ง
              dataLabels: {
                // ปรับให้แสดงข้อความบนแท่งกราฟ กรณีไม่ใส่ default เป็น center (relate กับ chartOptions.dataLabels)
                position: "top", // top, center, bottom
              },
              // colors: { // ทำพื้นหลังกราฟแท่งแต่ละอัน
              //   backgroundBarColors: [
              //     // chartColors.column.bg,
              //     // chartColors.column.bg,
              //     // chartColors.column.bg,
              //     // chartColors.column.bg,
              //     // chartColors.column.bg,
              //   ],
              //   backgroundBarRadius: 10,
              // },
            },
          },
          dataLabels: {
            enabled: true,
            offsetY: -20,
            style: {
              colors: [],
            },
          },
          legend: {
            show: false,
            position: "bottom",
            fontSize: "10px",
            fontFamily: "Montserrat",
            horizontalAlign: "left",
          },
          stroke: {
            show: false,
            colors: ["transparent"],
          },
          grid: {
            xaxis: {
              lines: {
                show: false,
              },
            },
          },
          xaxis: {
            labels: {
              show: true,
            },
            categories: [],
          },
          yaxis: {
            // opposite: isRtl,
          },
          noData: {
            text: "ไม่พบข้อมูล",
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "18px",
              fontFamily: undefined,
            },
          },
        },
      },
    };
  },
  setup(props) {
    let dashbaordRoleMode = null;
    /* เจ้าหน้าที่กทม. ส่วนกลาง */
    if (
      userData.selectedUserRole().value ===
        "fb3c1330-6e09-454c-93cc-15051d5bf18e" &&
      (userData.selectedUserRole().district === null ||
        userData.selectedUserRole().district === "null")
    ) {
      dashbaordRoleMode = "center";
    } else if (userData.selectedUserRole().district != null) {
      /* เจ้าหน้าที่กทม. เขต */
      dashbaordRoleMode = "district";
    } else {
      /// ตอนนี้ถ้าตก else ให้นับเป็นส่วนกลางไปก่อน
      dashbaordRoleMode = "center";
    }
    console.log("dashbaordRoleMode:", dashbaordRoleMode);
    return { dashbaordRoleMode };
  },
  mounted() {
    console.log("dashbaordRoleMode", this.dashbaordRoleMode);
    if (this.dashbaordRoleMode == "district") {
      //this.compliantStatistics.total = 20;
      //this.compliantStatistics.inprocess = 5;
      //this.compliantStatistics.terminated = 15;
    }
    this.getDashbboardData();
  },
  methods: {
    getDashbboardData() {
      this.getComplaintSummary();
      this.getComplaintChart();
    },
    getComplaintSummary() {
      const params = {};
      if (this.dashbaordRoleMode == "district") {
        params.districtCode = userData.selectedUserRole().district;
      }
      provinceStore
        .getComplaintBangkokSummary(params)
        .then((response) => {
          if (response.data.success && response.data.data) {
            this.compliantStatistics = response.data.data;
          }
        })
        .catch((error) => {
          console.error("getComplaintSummary error:", error);
        });
    },
    getComplaintChart() {
      const params = {};
      if (this.dashbaordRoleMode == "district") {
        params.districtCode = userData.selectedUserRole().district;
      }
      provinceStore
        .getComplaintBangkokChart(params)
        .then((response) => {
          console.log("getComplaintChart response:", response.data.data.data);
          if (response.data.success && response.data.data) {
            let seriesData = response.data.data.data.map((item) => item.count);

            this.columChart.series[0].data = seriesData;

            this.columChart.chartOptions.xaxis.categories = response.data.data.data.map(
              (item) => item.monthName
            );
            this.dashboardYear = response.data.data.yearBeYear;

            this.$refs["barChart"].updateSeries([
              {
                data: this.columChart.series,
              },
              false,
              true,
            ]);

            // this.$refs["lineChart"].updateOptions({
            //   labels: this.lineChart.chartOptions.labels,
            // });
            this.$refs["barChart"].refresh();
          }
        })
        .catch((error) => {
          console.error("getComplaintSummary error:", error);
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.box-main {
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;
  height: 150px;
  border-top-style: solid;
  border-top-color: #bff1b9;
  border-top-width: 20px;
  border-radius: 0;

  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.box-main:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  background-color: #f8f9fa; /* light gray highlight */
  border-top-color: #00904b;
}
.box-sub {
  // background-color: #f2f1fc;
  background-color: whitesmoke;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.box-text-size {
  font-size: 16px !important;
}

.card-underline {
  // border-bottom-style: solid;
  border-bottom-color: black;
}

/* ตั้งสี primary แค่ที่เดียว */
:root {
  --primary: #00904b !important; /* <<< เปลี่ยนสีตรงนี้ครั้งเดียว */
  --primary-dark: #017b40 !important;
}

/* Override สี primary ของ Bootstrap 4 ทั้งหน้า */
/* TEXT */
.text-primary {
  color: var(--primary) !important;
}

/* BACKGROUND */
.bg-primary {
  background-color: var(--primary) !important;
}

/* BORDER */
.border-primary {
  border-color: var(--primary) !important;
}

/* BUTTON - PRIMARY */
.btn-primary {
  color: #fff !important;
  background-color: var(--primary) !important;
  border-color: var(--primary-dark) !important;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.show > .btn-primary.dropdown-toggle {
  background-color: var(--primary-dark) !important;
  border-color: var(--primary-dark) !important;
}

.btn-primary.disabled,
.btn-primary:disabled {
  background-color: var(--primary-light) !important;
  border-color: var(--primary-light) !important;
}

/* BUTTON - OUTLINE PRIMARY */
.btn-outline-primary {
  color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:active,
.btn-outline-primary.active,
.show > .btn-outline-primary.dropdown-toggle {
  color: #fff !important;
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: var(--primary-light) !important;
  border-color: var(--primary-light) !important;
}

/* BADGE */
.badge-primary {
  background-color: var(--primary) !important;
  color: #fff !important;
}

/* ALERT */
.alert-primary {
  background-color: var(--primary) !important;
  border-color: var(--primary-dark) !important;
  color: #fff !important;
}

/* LIST GROUP */
.list-group-item-primary {
  background-color: var(--primary) !important;
  color: #fff !important;
}

/* TABLE */
.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: var(--primary) !important;
  color: #fff !important;
}

/* PROGRESS BAR */
.progress-bar.bg-primary,
.progress-bar-primary {
  background-color: var(--primary) !important;
}

/* PAGINATION */
.page-item.active .page-link {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.page-link:hover {
  color: var(--primary) !important;
}

/* CARD */
.card.border-primary {
  border-color: var(--primary) !important;
}

.card-header.bg-primary,
.card-header.border-primary {
  background-color: var(--primary) !important;
  border-color: var(--primary-dark) !important;
}

/* NAVBAR (text-primary, bg-primary, border-primary already cover most) */
.navbar-light .navbar-nav .nav-link.text-primary:hover {
  color: var(--primary-dark) !important;
}

.dark-layout .nav-tabs .nav-item .nav-link.active,
.dark-layout .nav-pills .nav-item .nav-link.active,
.dark-layout .nav-tabs.nav-justified .nav-item .nav-link.active {
  color: var(--primary-dark);
}

/* LINKS */
a.text-primary:hover,
a.text-primary:focus {
  color: var(--primary-dark) !important;
}

[dir="ltr"] .main-menu.menu-light .navigation > li ul .active {
  background: linear-gradient(118deg, var(--primary), rgba(0, 144, 75, 0.7));
}

[dir] .main-menu.menu-light .navigation > li ul .active {
  box-shadow: 0 0 10px 1px rgba(0, 144, 75, 0.7);
  border-radius: 4px;
}

.main-menu .navbar-header .navbar-brand .brand-text {
  color: var(--primary);
}

.dark-layout .main-menu .collapse-toggle-icon {
  color: var(--primary) !important;
}

a {
  color: var(--primary);
}

.nav-tabs .nav-link.active {
  color: var(--primary);
}

[dir="ltr"] .nav-tabs .nav-link:after {
  left: 0;
  background: linear-gradient(
    30deg,
    var(--primary),
    rgba(0, 144, 75, 0.5)
  ) !important;
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: var(--primary);
}

[dir] .dropdown-item:hover,
[dir] .dropdown-item:focus {
  background-color: rgba(0, 144, 75, 0.12);
}

[dir] .dropdown-item.active,
[dir] .dropdown-item:active {
  background-color: var(--primary);
}

[dir] .btn-primary:hover:not(.disabled):not(:disabled) {
  box-shadow: 0 8px 25px -8px var(--primary);
}

.badge.badge-light-primary {
  color: var(--primary) !important;
}

.brand-logo img {
  content: url("/250px-bangkok.png");
  max-height: 62px;
}

[dir] .custom-control-input:checked ~ .custom-control-label::before {
  border-color: var(--primary);
  background-color: var(--primary);
}

[dir]
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::before,
[dir]
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label::before {
  box-shadow: 0 2px 4px 0 rgba(0, 144, 75, 0.4) !important;
}

[dir]
  .custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: rgba(0, 144, 75, 0.65);
}

[dir]
  .custom-control-input:not(:disabled):active
  ~ .custom-control-label:before {
  background-color: var(--primary);
  border-color: var(--primary);
}

.vs__dropdown-option--selected.vs__dropdown-option--highlight {
  color: #fff !important;
  background-color: var(--primary) !important;
}

#app [dir] .vs--open .vs__dropdown-toggle {
  border-color: var(--primary);
  border-bottom-color: var(--primary);
  box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
}

#app [dir] .vs__dropdown-option--highlight {
  background-color: rgba(0, 144, 75, 0.12) !important;
}

#app [dir] .vs__dropdown-option--selected {
  background-color: var(--primary) !important;
}

#app [dir] .vs__dropdown-option--selected.vs__dropdown-option--highlight {
  background-color: var(--primary) !important;
}

#app .vs__dropdown-option--highlight {
  color: var(--primary) !important;
}

#app .vs__dropdown-option--selected {
  background-color: var(--primary) !important;
  color: #fff !important;
  position: relative;
}

a:hover {
  color: var(--primary-dark);
  text-decoration: none;
}

.dark-layout a:hover {
  color: var(--primary-dark);
}

[dir="ltr"] .main-menu.menu-light .navigation > li.active > a {
  background: linear-gradient(118deg, var(--primary), rgba(0, 144, 75, 0.7));
}

[dir] .main-menu.menu-light .navigation > li.active > a {
  box-shadow: 0 0 10px 1px rgba(0, 144, 75, 0.7);
  border-radius: 4px;
}
</style>
